module.exports = __webpack_public_path__ + "static/media/racquet.0d7ce288.svg";